import { GIFT_CARD_INQUIRY_ANALYTICS_PAGE_DESCRIPTION } from '../../../common/constants';

export const ANALYTICS = {
  prefix: GIFT_CARD_INQUIRY_ANALYTICS_PAGE_DESCRIPTION,
  pageView: {
    pageDescription: GIFT_CARD_INQUIRY_ANALYTICS_PAGE_DESCRIPTION,
    templateType: 'gift card',
  },
  ui: {
    buttons: {
      getBalance: `${GIFT_CARD_INQUIRY_ANALYTICS_PAGE_DESCRIPTION}:get balance`,
      contactUs: `${GIFT_CARD_INQUIRY_ANALYTICS_PAGE_DESCRIPTION}:contact us`,
    },
    modal: {
      save: `${GIFT_CARD_INQUIRY_ANALYTICS_PAGE_DESCRIPTION}:save to online account`,
      notNow: `${GIFT_CARD_INQUIRY_ANALYTICS_PAGE_DESCRIPTION}:not now`,
      cancel: `${GIFT_CARD_INQUIRY_ANALYTICS_PAGE_DESCRIPTION}:close modal`,
    },
  },
};

export const FORM_ERROR_MESSAGES = {
  form: {
    invalid: 'Your gift card has a $0 balance or the information entered is incorrect.',
  },
  cardNumber: {
    required: 'This field is required.',
    min_length: 'Must be 12 or 19 characters.',
  },
  cardPin: {
    required: 'This field is required.',
    min_length: 'Must be 4 numbers.',
    special_characters: 'Letters and special characters are not allowed.',
  },
};
